// extracted by mini-css-extract-plugin
module.exports = {"section":"Weather_section__t3Vd0","desktop":"Weather_desktop__MxiyA","mobile":"Weather_mobile__hJdeO"};